module.exports = __webpack_public_path__ + "img/SWP_Sword_1H_01 (2).d10f8feb.png";